import { SelectOption, withForm } from '@stern-ui/ui';

import { patientAssignmentFormOptions } from './patientAssignmentFormOptions';

export const PatientAssignmentForm = withForm({
	...patientAssignmentFormOptions,
	props: {
		isLoading: false,
		patientStatusSelectOptions: [] as SelectOption[],
		studySelectOptions: [] as SelectOption[],
	},
	render: ({ form, patientStatusSelectOptions, studySelectOptions, isLoading }) => {
		return (
			<div
				className={`w-full grid grid-cols md:grid-cols-2 gap-4 md:gap-8 mt-6 pb-5 ${isLoading ? 'opacity-0' : ''}`}
			>
				<form.AppField name='study_identifier'>
					{(field) => (
						<field.SelectField label='Study' options={studySelectOptions || []} />
					)}
				</form.AppField>
				<form.AppField name='patient_status'>
					{(field) => (
						<field.SelectField
							label='Patient status'
							options={patientStatusSelectOptions}
						/>
					)}
				</form.AppField>
			</div>
		);
	},
});
